import PropTypes from "prop-types";
import React, { useEffect, useState, Fragment } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { Routes, Route, useLocation, useSearchParams, useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";
import { authProtectedRoutes, publicRoutes } from "./routes/index";
import Authmiddleware from "./routes/route";
import VerticalLayout from "./components/VerticalLayout/";
import HorizontalLayout from "./components/HorizontalLayout/";
import NonAuthLayout from "./components/NonAuthLayout";
import { getProfile as onGetProfile } from "./helpers/api_rombo_helper";
import { infoUser, lastPath, loginUser, logoutUser } from "./store/actions";
import "./assets/scss/theme.scss";

const App = (props) => {
  
  const [userInfo, setUserInfo] = useState({ permissions: [] })
  const [searchParams, setSearchParams] = useSearchParams()
  const dispatch = useDispatch();
  const history = useNavigate();
  const { isAuthenticated, getAccessTokenSilently, loginWithRedirect } = useAuth0();

  const LayoutProperties = createSelector(
    (state) => state.Layout,
    (layout) => ({
      layoutType: layout.layoutType,
    })
  );

  const { layoutType } = useSelector(LayoutProperties);
  
  const LoginProperties = createSelector(
    (state) => state.Login,
    (Login) => ({
      token: Login.token,
      loading: Login.loading,
      data: Login.data
    })
  );

  const { token, loading, data } = useSelector(LoginProperties);

  function getLayout(layoutType) {
    let layoutCls = VerticalLayout;
    switch (layoutType) {
      case "horizontal":
        layoutCls = HorizontalLayout;
        break;
      default:
        layoutCls = VerticalLayout;
        break;
    }
    return layoutCls;
  }

  const location = useLocation();
  const Layout = getLayout(layoutType);

  useEffect(() => {
    localStorage.setItem("typeService", searchParams.get("typeService"));
    dispatch(lastPath(location.pathname + location.search));
  }, [dispatch, location, searchParams]);

  useEffect(() => {
    const restoreAuth = async () => {
      if (!isAuthenticated) return;
      try {
        const token = await getAccessTokenSilently();
        dispatch(loginUser(token));
      } catch (err) {
        console.error("Could not restore token:", err.message);

        localStorage.clear();
        sessionStorage.clear();
        dispatch(logoutUser(history));

        loginWithRedirect({
          appState: { returnTo: location.pathname + location.search },
          authorizationParams: {
            redirect_uri: window.location.origin,
          },
        });
      }
    };
    restoreAuth();
  }, [
    isAuthenticated,
    getAccessTokenSilently,
    dispatch,
    history,
    loginWithRedirect,
    location,
  ]);

  useEffect(() => {
    const bearer = token?.Authorization || "";
    if (!bearer.startsWith("Bearer ") || bearer === "Bearer ") return;
    onGetProfile(token)
      .then((response) => {
        setUserInfo(response);
        dispatch(infoUser(response));
      })
      .catch((err) =>
        console.error("Error fetching profile:", err.response || err)
      );
  }, [token, dispatch]);

  return (
    <Fragment>
      <Routes>
        {publicRoutes.map((route, idx) => (
          <Route
            path={route.path}
            element={<NonAuthLayout>{route.component}</NonAuthLayout>}
            key={idx}
            exact={true}
          />
        ))}

        {authProtectedRoutes.map((route, idx) => (
          <Route
            path={route.path}
            element={
              <Authmiddleware>
                <Layout>{route.component}</Layout>
              </Authmiddleware>
            }
            key={idx}
            exact={true}
          />
        ))}
      </Routes>
    </Fragment>
  );
};

App.propTypes = {
  layout: PropTypes.any,
};

const mapStateToProps = (state) => {
  return {
    layout: state.Layout,
  };
};

export default connect(mapStateToProps, null)(App);
